import { useEffect } from 'react';

/**
 * Escape closes a modal, as a click beside it does (old DP:2407). Not one already handled
 * (preventDefault): a window over this one closed itself with it, e.g. a file's preview.
 */
export function useEscape(onClose: () => void) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && !e.defaultPrevented && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [onClose]);
}
